import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { environment } from 'src/environments/environment';
@Injectable({ providedIn: 'root' })
export class SocialSecurityService extends BaseService {
    getAdditionalContribution() {
        const url = `${environment.portalApi}/SocialSecurity/PagedAdditionalContribution`;
        return this.http.get(url, { headers: this.createHeader() });
    }
    getContributionHistory() {
        const url = `${environment.portalApi}/SocialSecurity/PagedContributionHistory`;
        return this.http.get(url, { headers: this.createHeader() });
    }
    SearchInvoicesAvailable() {
        const url = `${environment.portalApi}/SocialSecurity/SearchInvoicesAvailable`;
        return this.http.get(url, { headers: this.createHeader() });
    }
    getContributionsCsv(filter: any) {
        const url = `${environment.portalApi}/SocialSecurity/ContributionsCsv?` + this.paramsToQueryString(filter);
        return this.http.get(url, { headers: this.createHeader(), responseType: 'blob' });
    }
    getResgateReserva() {
        const url = `${environment.portalApi}/SocialSecurity/ResgateReserva`;
        return this.http.get(url, { headers: this.createHeader() });
    }
    getOrigensAporte() {
        const url = `${environment.portalApi}/SocialSecurity/GetOrigensAporte`;
        return this.http.get(url, { headers: this.createHeader() });
    }
    CobrancaJudicialBoleto() {
        const url = `${environment.portalApi}/SocialSecurity/CobrancaJudicialBoleto`;
        return this.http.get(url, { headers: this.createHeader() });
    }
    getDependentes() {
        const url = `${environment.portalApi}/SocialSecurity/Dependant`;
        return this.http.get(url, { headers: this.createHeader() });
    }
    getPersonData() {
        const url = `${environment.portalApi}/SocialSecurity/PersonData`;
        return this.http.get(url, { headers: this.createHeader() });
    }
    PostGenerateInvoice(invoice: any) {
        const url = `${environment.portalApi}/SocialSecurity/GenerateInvoice`;
        return this.http.post(url, invoice, { headers: this.createHeader() });
    }
    GetMaxValueAmortizacao(data: any) {
        const url = `${environment.portalApi}/SocialSecurity/GetMaximoAmortizacao?data=${data}`;
        return this.http.get(url, { headers: this.createHeader() });
    }
    ValidaBoletoAtivo() {
        const url = `${environment.portalApi}/SocialSecurity/ValidaEmprestimoAtivo`;
        return this.http.get(url, { headers: this.createHeader() });
    }
    ValidateExistenceAporte(data: any) {
        const url = `${environment.portalApi}/SocialSecurity/GetInvoicesAporte?data=${data}`;
        return this.http.get(url, { headers: this.createHeader() });
    }
    ValidateExistenceEmprestimo(data: any) {
        const url = `${environment.portalApi}/SocialSecurity/GetInvoicesEmprestimo?data=${data}`;
        return this.http.get(url, { headers: this.createHeader() });
    }
    ValidaFeriado(data: any) {
        const url = `${environment.portalApi}/SocialSecurity/ValidaFeriado?data=${data}`;
        return this.http.get(url, { headers: this.createHeader() });
    }

    ValidaListaFeriado(){
        const url = `${environment.portalApi}/SocialSecurity/ListaFeriadosMes`;
        return this.http.get(url, { headers: this.createHeader() });
    }

    getReserve() {
        const url = `${environment.portalApi}/SocialSecurity/Reserve`;
        return this.http.get(url, { headers: this.createHeader() });
    }
    getDesignated() {
        const url = `${environment.portalApi}/SocialSecurity/Designated`;
        return this.http.get(url, { headers: this.createHeader() });
    }
    getIntakes(filter: any) {
        const url = `${environment.portalApi}/SocialSecurity/PagedAdditionalContribution?` + this.paramsToQueryString(filter);
        return this.http.get(url, { headers: this.createHeader() });
    }
    getContributions(filter: any) {
        const url = `${environment.portalApi}/SocialSecurity/PagedContribution?` + this.paramsToQueryString(filter);
        return this.http.get(url, { headers: this.createHeader() });
    }
    postContributionHistory(filter: any) {
        const url = `${environment.portalApi}/Declaration/GeneratePDF`;
        return this.http.post(url, filter, { headers: this.createHeader(), responseType: 'blob' });
    }
    getPagedContributionHistory(filter: any) {
        const url = `${environment.portalApi}/SocialSecurity/PagedContributionHistory?` + this.paramsToQueryString(filter);
        return this.http.get(url, { headers: this.createHeader() });
    }
    getBenefitGranted() {
        const url = `${environment.portalApi}/SocialSecurity/BenefitGranted`;
        return this.http.get(url, { headers: this.createHeader() });
    }
    getPaymentAnalyze(filter: any) {
        const url = `${environment.portalApi}/SocialSecurity/PaymentAnalyze?` + this.paramsToQueryString(filter);
        return this.http.get(url, { headers: this.createHeader() });
    }
    getSimulation(filter: any) {
        const url = `${environment.portalApi}/SocialSecurity/Simulation?` + this.paramsToQueryString(filter);
        return this.http.get(url, { headers: this.createHeader() });
    }
    getPaymentAnalyzePdf(prop: any) {
        // const url = `${environment.portalApi}/SocialSecurity/GeneratePDF?reference=${month}`;
        const url = `${environment.portalApi}/SocialSecurity/GeneratePDF?` + this.paramsToQueryString(prop);
        return this.http.get(url, { headers: this.createHeader(), responseType: 'blob', observe: 'response' });
    }
    postIntakeHistory(filter: any) {
        const url = `${environment.portalApi}/Declaration/GeneratePDF`;
        return this.http.post(url, filter, { headers: this.createHeader(), responseType: 'blob' });
    }
    getLastIntake(filter: any) {
        const url = `${environment.portalApi}/SocialSecurity/GetLastAdditionalContribution?` + this.paramsToQueryString(filter);
        return this.http.get(url, { headers: this.createHeader(), observe: 'response' });
    }
    getIntakeValue() {
        const url = `${environment.portalApi}/SocialSecurity/ValueTributary`;
        return this.http.get(url, { headers: this.createHeader() });
    }
    listLoans(filter: any) {
        filter.page--;
        const url = `${environment.portalApi}/SocialSecurity/GetHomePrevLoan?` + this.paramsToQueryString(filter);
        return this.http.get(url, { headers: this.createHeader() });
    }
    getLoanUrl() {
        const url = `${environment.portalApi}/SocialSecurity/GetHomePrevLoanUrl`;
        return this.http.get(url, { headers: this.createHeader() });
    }
}
